"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var queryString = require("query-string");
var sok_ui_1 = require("@caddigital/sok-ui");
var currentActions = require("@caddigital/sok-reducers/lib/actions/auth/current");
var oauth2Actions = require("@caddigital/sok-reducers/lib/actions/auth/oauth2");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var Types = require("types");
var translate_1 = require("utils/translate");
var cookies_1 = require("utils/cookies");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var LanguageSelector_1 = require("components/LanguageSelector");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var logo = '/assets/images/SokoPro_logo_blue.svg';
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        translationStatus: state.translations.translations.status,
        user: state.auth.current.user,
        token: state.auth.current.token,
        isLogin: state.auth.login.status,
        oauth2: state.auth.oauth2,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    redirectToLogin: function (currentLanguage) {
        return dispatch((0, connected_react_router_1.replace)("/".concat(currentLanguage, "/login")));
    },
    getUserInfo: function () { return dispatch(currentActions.getUserinfoRequestAction()); },
    setOauth2Params: function (params) {
        return dispatch(oauth2Actions.setOauth2Params(params));
    },
    getClient: function (client) {
        return dispatch(oauth2Actions.getOauth2ClientRequest(client));
    },
    cancel: function (currentLanguage) {
        (0, cookies_1.removeCookie)('address_before_login');
        dispatch((0, connected_react_router_1.replace)("/".concat(currentLanguage, "/login")));
    },
    fetchLanguage: function (language) {
        (0, translate_1.setLanguage)(language);
        dispatch((0, translations_1.fetchLanguageRequest)(language));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
function validateOauth2(oauth2) {
    var errors = [];
    if (!oauth2.response_type) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', [
            'response_type'
        ]));
    }
    if (oauth2.response_type && oauth2.response_type !== 'code') {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/responseTypeIsNotAllowed', [oauth2.response_type]));
    }
    if (!oauth2.client_id) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', ['client_id']));
    }
    if (!oauth2.redirect_uri) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', [
            'redirect_uri'
        ]));
    }
    if (!oauth2.scope) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', ['scope']));
    }
    if (!oauth2.state) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', ['state']));
    }
    if (oauth2.code_challenge_method && !oauth2.code_challenge) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', [
            'code_challenge'
        ]));
    }
    if (oauth2.code_challenge && !oauth2.code_challenge_method) {
        errors.push((0, translation_1.getLocalization)('oauth2/authorize/validationError/missing', [
            'code_challenge_method'
        ]));
    }
    return errors;
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('hasError', 'setHasError', false), (0, recompose_1.withState)('errors', 'setErrors', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var parsed = queryString.parse(location.search);
        var oauth2 = {
            response_type: parsed.response_type,
            client_id: parsed.client_id,
            redirect_uri: parsed.redirect_uri,
            scope: parsed.scope,
            state: parsed.state,
            code_challenge: parsed.code_challenge || null,
            code_challenge_method: parsed.code_challenge_method || null
        };
        var errors = validateOauth2(oauth2);
        if (errors.length === 0) {
            this.props.setOauth2Params(oauth2);
        }
        else {
            this.props.setErrors(errors);
            this.props.setHasError(true);
        }
        if (!this.props.token) {
            var url = window.location.pathname;
            var search = window.location.search;
            (0, cookies_1.setCookie)('address_before_login', url + search);
            this.props.redirectToLogin(this.props.selectedLanguage);
        }
        else if (this.props.isLogin === 'LOGGED_IN') {
            this.props.getUserInfo();
            this.props.getClient({
                client_id: oauth2.client_id,
                scope: oauth2.scope,
                redirect_uri: oauth2.redirect_uri
            });
        }
    },
    componentWillUpdate: function (nextProps) {
        if (nextProps.isLogin === 'EXPIRED') {
            this.props.redirectToLogin(this.props.selectedLanguage);
        }
        else if (this.props.isLogin !== nextProps.isLogin &&
            nextProps.isLogin === 'LOGGED_IN') {
            this.props.getUserInfo();
        }
        if (nextProps.oauth2.status !== 'REDIRECT' &&
            this.props.oauth2.params !== nextProps.oauth2.params &&
            nextProps.oauth2.params) {
            this.props.getClient({
                client_id: nextProps.oauth2.params.client_id,
                scope: nextProps.oauth2.params.scope,
                redirect_uri: nextProps.oauth2.params.redirect_uri
            });
        }
        if (nextProps.oauth2.status === 'REDIRECT') {
            window.location.href = "".concat(__APIBASEURL__, "api/oauth2/authorize").concat(window.location.search);
        }
    }
}));
var GetPermissionList = function (params) {
    var permissions = [];
    if (!params)
        return permissions;
    var scopes = params.scope.split('+');
    if (scopes.includes('full_access')) {
        permissions.push(React.createElement("li", { key: 'full_access' }, (0, translation_1.getLocalization)('oauth2/authorize/scope/full_access')));
    }
    return permissions;
};
var Loading = function () { return (React.createElement("div", { className: 'content' },
    React.createElement(sok_ui_1.LoadingSpinner, null),
    (0, translation_1.getLocalization)('oauth2/authorize/pleaseWait'))); };
var OAuth2 = enhance(function (props) { return (React.createElement("div", { className: 'oauth2-view' }, props.translationStatus === 'FETCHING' ? (React.createElement("div", { className: 'language-spinner' },
    React.createElement(sok_ui_1.LoadingSpinner, null))) : (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'logo' },
        React.createElement("img", { src: logo, width: "123", height: "16" })),
    React.createElement("div", { className: 'language-selector' },
        React.createElement(LanguageSelector_1.default, { languageCode: props.selectedLanguage, updateUserLanguage: props.fetchLanguage, previewSize: '32x24' })),
    props.user.foldL(function () { return (React.createElement(Loading, null)); }, function (user) {
        if (props.hasError) {
            return (React.createElement("div", { className: 'content' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('oauth2/authorize/validationError')),
                React.createElement("ul", null, props.errors.map(function (error, i) { return (React.createElement("li", { key: "error-".concat(i) }, error)); }))));
        }
        if (props.oauth2.status === 'REDIRECT' ||
            props.isLogin === 'STANDBY' ||
            props.isLogin === 'LOGGING_IN' ||
            props.oauth2.clientStatus === 'STANDBY' ||
            props.oauth2.clientStatus === 'FETCHING') {
            return React.createElement(Loading, null);
        }
        return props.oauth2.clientName.foldL(function () { return (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('oauth2/authorize/generalParametersError') })); }, function (clientName) { return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'content', key: 'content' },
                React.createElement("h2", null, (0, translation_1.getLocalization)('oauth2/authorize/hiUser', [
                    user.firstName || '',
                    user.lastName || ''
                ])),
                React.createElement("b", null,
                    (0, translation_1.getLocalization)('oauth2/authorize/isRequestingPermission', [clientName]),
                    ":"),
                React.createElement("ul", null, GetPermissionList(props.oauth2.params))),
            React.createElement("form", { method: 'POST', action: "".concat(__APIBASEURL__, "api/oauth2/authorize").concat(window.location.search) },
                React.createElement("div", { className: 'buttons', key: 'buttons' },
                    React.createElement(sok_ui_1.Button, { type: 'submit', size: 'large', color: 'blue', text: (0, translation_1.getLocalization)('oauth2/authorize/button/authorize') }),
                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'dark-gray', text: (0, translation_1.getLocalization)('oauth2/authorize/button/cancel'), onClick: function () { return props.cancel(props.selectedLanguage); } }))))); });
    }))))); });
exports.default = OAuth2;
